/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import ReferenceCodesService from '@/services/ReferenceCodesService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`ReferenceCodes/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getReferenceCodeConfig = handler(
  'getReferenceCodeConfig',
  ReferenceCodesService.getReferenceCodeConfig
);

export const putReferenceCodeConfig = handler(
  'putReferenceCodeConfig',
  ReferenceCodesService.putReferenceCodeConfig
);

export const getGlobalReferenceCodeConfig = handler(
  'getGlobalReferenceCodeConfig',
  ReferenceCodesService.getGlobalReferenceCodeConfig
);

export const putGlobalReferenceCodeConfig = handler(
  'putGlobalReferenceCodeConfig',
  ReferenceCodesService.putGlobalReferenceCodeConfig
);

export const getExclusiveReferenceCodeConfig = handler(
  'getExclusiveReferenceCodeConfig',
  ReferenceCodesService.getExclusiveReferenceCodeConfig
);

export const putExclusiveReferenceCodeConfig = createAsyncThunk(
  'ReferenceCodes/putExclusiveReferenceCodeConfig',
  async ({ silent, ...config }) => {
    const data = await ReferenceCodesService.putExclusiveReferenceCodeConfig(
      config
    );
    return data;
  }
);
